import { takeLatest, all, fork, call, put } from 'redux-saga/effects';
import Actions from 'actions';
import api from 'api';

function* sendEnquiryEmail({ data, callbacks }) {
  try {
    const response = yield call(api.sendEnquiryEmail, data);
    yield put(Actions.sendEnquiryEmailSuccess(response.data));
    if (typeof callbacks.success === 'function') {
      yield call(callbacks.success, response.data);
    }
  } catch (error) {
    yield put(Actions.sendEnquiryEmailFail(error));
    if (typeof callbacks.failure === 'function') {
      yield call(callbacks.failure, error);
    }
  }
}

function* watchsendEnquiryEmail() {
  yield takeLatest(Actions.SEND_ENQUIRY_EMAIL_REQUEST, sendEnquiryEmail);
}

export default function* create() {
  yield all([fork(watchsendEnquiryEmail)]);
}
